export default __webpack_public_path__ + "static/media/Insurance.46324d6e.svg";